import * as ko from "knockout";
import { searchResult, SolutionSearchCriteria, solution_dto } from "organized";
import { LookupStorage } from "portalframework";
import * as _ from "lodash";
import { BaseService } from "./_common/_baseService";
import { SearchResult } from "entitiesE";
import { portalHttpService } from "./_common/httpService";
class SolutionsService extends BaseService {
  constructor() {
    super("solutions");
  }

  getScreenData = async (): Promise<void> => {
    const requiredLookups = ["C_PHENOMENOM_CODE", "C_PHENOMENON_CLASS", "PLACEPERSONS"];

    let lookupsToFetch = _.difference(requiredLookups, LookupStorage.lookupStorage.lookupNames());
    let data = ko.toJSON({ requiredLookups: lookupsToFetch });
    const result = await portalHttpService.post(`${this.baseApiUrl()}/GetScreenData`, data);
    this.setLookups(lookupsToFetch, result);
  };

  getWhitelistedModels = async (): Promise<{ display_name: string; value: string }[]> => {
    return await portalHttpService.get<{ display_name: string; value: string }[]>(
      `${this.baseApiUrl()}/GetWhiteListedModels`,
    );
  };

  getSolutions = async (criteria: SolutionSearchCriteria): Promise<searchResult<solution_dto[]>> => {
    const result: any = await portalHttpService.post(`${this.baseApiUrl()}/GetSolutions`, ko.toJSON(criteria));

    const solutions = result.result.map((s) => new solution_dto(s));
    return new searchResult<solution_dto[]>({
      count: result.count,
      result: solutions,
    });
  };
  getSolutionById = async (solutionId: string): Promise<solution_dto> => {
    const result: any = await portalHttpService.get(`${this.baseApiUrl()}/GetSolutionById/${solutionId}`);
    return new solution_dto(result);
  };

  public searchModels = async (criteria: string): Promise<SearchResult> => {
    const result: any = await portalHttpService.post(
      `${this.baseApiUrl()}/SearchModels`,
      ko.toJSON({ model_id: criteria, Rows: 15, Page: 0 }),
    );

    const models = result.result;
    return new SearchResult({
      count: result.count,
      data: models,
    });
  };

  public getExistingSolutionsForRequest = async (
    request_id: string,
    should_update_cache: boolean = false,
  ): Promise<{ result: solution_dto[]; last_updated: string; model_id_weight: number }> => {
    const data = await portalHttpService.post<{ result: any[]; last_updated: string; model_id_weight: number }>(
      `${this.baseApiUrl()}/GetSolutionForRequestId`,
      ko.toJSON({
        request_id,
        should_update_cache,
      }),
    );

    return {
      last_updated: data.last_updated,
      result: data.result.map((s) => new solution_dto(s)),
      model_id_weight: data.model_id_weight,
    };
  };

  public acceptSolution = async (usedSolution: {
    request_id: string;
    solution_id: string;
    rating: number;
    comment: string;
  }) => {
    await portalHttpService.post<void>(`${this.baseApiUrl()}/AcceptSolutionForRequestId`, ko.toJSON(usedSolution));
  };

  public incrementSolutionUsage = async (solution_id: string, request_id: string = null): Promise<void> => {
    await portalHttpService.post<void>(
      `${this.baseApiUrl()}/IncrementSolutionUsage`,
      ko.toJSON({ solution_id, request_id }),
    );
  };

  public getSolutionUsage = async (request_id: string) => {
    return await portalHttpService.post<any[]>(`${this.baseApiUrl()}/GetSolutionsUsage`, ko.toJSON({ request_id }));
  };
}
export const solutionsService = new SolutionsService();
